export default "__VITE_ASSET__B$dLMJKO__"